<template>
  <bootstrap-nav id="navMenu" :items="items" item-class="" :active="activePage"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BootstrapNav from '@/components/ui/BootstrapNav.vue';

export default defineComponent({
  name: 'DssMenu',
  components: { BootstrapNav },
  computed: {
    items() {
      return [
        { name: this.$t('dss.page.personal.title'), push: '/personal-info' },
        { name: this.$t('dss.page.security.title'), push: '/sign-in-and-security' },
        {
          name: this.$t('dss.label.help'), subItems: [
            { name: this.$t('dss.label.faq'), link: this.$t('dss.link.faq'), target: '_blanc' },
            { name: this.$t('dss.label.contact'), link: this.$t('dss.link.contact'), target: '_blanc' },
          ]
        }
      ];
    },
    activePage() {
      console.info('route.path: ', this.$route.path)
      return this.$route.path == '/sign-in-and-security' ? 1 : 0;
    },
  }
});
</script>
